/* @jsx jsx */

import { jsx, css } from "@emotion/react"
import {
  KennisCardsModule,
  moduleIntro,
  Page,
  PageComponent,
} from "@src/components"
import { KennisBubblesModule } from "@src/components/kennis-bubbles"
import Layout from "@src/components/layout"
import { colors } from "@src/style/variables"
import { translate } from "@src/utils"

export interface Props {
  data: {
    allDatoCmsKnowledge: {
      edges: {
        node: {
          originalId: string
          age?: number
          bodyNode?: any
          name?: string
          city?: string
          category?: string
        }
      }[]
    }
    datoCmsKennisPage: {
      title?: string
      bodyNode?: any
      categoriesTitle?: string
      categoriesBodyNode?: any
      content?: any
      categories: { title?: string; count?: number; descriptionNode?: any }[]
    }
  }
}
export const KennisPage: (locale: "nl" | "en") => React.FC<Props> = locale => ({
  data,
}) => {
  const { title, bodyNode } = data.datoCmsKennisPage
  // console.log("uaeh", locale)

  return (
    <Layout locale={locale} headerColor={"white"}>
      {moduleIntro(title, bodyNode, "white", translate(locale, "knowledge"))}
      <KennisCardsModule data={data} />
      <div
        css={css`
          background-color: ${colors.gold};
        `}
      >
        {moduleIntro(
          data.datoCmsKennisPage.categoriesTitle,
          data.datoCmsKennisPage.categoriesBodyNode,
          "gold",
          ""
        )}
        <KennisBubblesModule data={data} />
      </div>
      {PageComponent(title, false, data.datoCmsKennisPage.content, locale)}
    </Layout>
  )
}
